import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../Firebase";
import firebase from "firebase";
import { country } from "../Allapis";
import { Apiurl } from "../api_urls";
import { riderlogin } from "../redux_store/RiderloginSlice";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { GToaster } from "../Components/g_toaster";
import { CircularProgress } from "@material-ui/core";
import LoginTabs from "../Components/LoginTabs";
import ForgotPasswordModal from "../Components/ForgotPassword";
import { Box, Modal } from "@mui/material";
import Termagree from "../Components/Termagree";
import { OpenInNew } from "@material-ui/icons";
import { setAuthToken } from "../api/axiosConfig";
const toster = new GToaster()

function Riderlogin() {
  const recaptchaVerifierRef = useRef(null);
  
  const objdata = {
    "country_code": "",
    "contact_number": "",
    "password": "",
    "email": "",
  }
  

  let navi = useNavigate();
  const dispatch = useDispatch()
  const url = Apiurl.DRIVER_LOGIN_URL
  const [obj, setobj] = useState({ ...objdata })
  const [otpdata, setotpdata] = useState(null);
  const [code, setcode] = useState(country);
  const [userdata, setuserdata] = useState(null);
  const [btnloader, setbtnloader] = useState(false)
  const [tab, setTab] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isagree, setisagree] = useState(false)
  function handlechange(key, value) {
    setobj({ ...obj, [key]: value })
  }


const createRecaptcha = async () => {
    // Remove previous verifier
    if (recaptchaVerifierRef.current) {
        try {
            recaptchaVerifierRef.current.clear();
        } catch (e) {
            console.log("Recaptcha clear error:", e);
        }

        recaptchaVerifierRef.current = null;
    }

    const container = document.getElementById("recaptcha-container");

    if (!container) {
        throw new Error("recaptcha-container not found");
    }

    const verifier = new firebase.auth.RecaptchaVerifier(
        "recaptcha-container",
        {
            size: "normal",

            callback: (response) => {
                console.log("reCAPTCHA solved");
            },

            "expired-callback": () => {
                console.log("reCAPTCHA expired");
            }
        }
    );

    recaptchaVerifierRef.current = verifier;

    await verifier.render();

    return verifier;
};

  async function logdata(e) {
    e.preventDefault();

    console.log("Login form submitted");
    console.log("Current tab:", tab);

    let newobj = !tab
        ? {
            email: obj?.email,
            password: obj?.password,
            role: "rider"
        }
        : {
            country_code: obj?.country_code,
            mobile: obj?.contact_number,
            role: "rider"
        };

    console.log("Login API data:", newobj);

    setbtnloader(true);
    localStorage.removeItem("persist:root");

    try {

        const response = await axios.post(
            !tab
                ? Apiurl.DRIVER_EMAIL_LOGIN_URL
                : Apiurl.DRIVER_LOGIN_URL,
            newobj,
            {
                // Important if your API returns 300/301
                validateStatus: function (status) {
                    return status >= 200 && status < 400;
                }
            }
        );

        console.log("Backend response:", response);
        console.log("Backend status:", response.status);

        if (response.status === 300) {

            toster.warning({
                title: "This contact no. is not registered. Please check your contact."
            });

            setbtnloader(false);
            return;
        }

        if (response.status === 301) {

            toster.warning({
                title: "Please Check Your Password"
            });

            setbtnloader(false);
            return;
        }

        if (response.status === 202) {

            toster.warning({
                title: "Your account status is inactive. Please contact the admin."
            });

            setbtnloader(false);
            return;
        }

        if (response.status !== 200) {

            toster.error({
                title: "Something went wrong in login"
            });

            setbtnloader(false);
            return;
        }

        console.log("Backend login successful");

        /*
         * EMAIL LOGIN
         */
        if (!tab) {

            localStorage.setItem(
                "access_token",
                response.data.access_token
            );

            localStorage.setItem(
                "role",
                response.data.data.role
            );

            setuserdata(response.data.data);

            userLogged(response.data.data);

            return;
        }

        /*
         * PHONE LOGIN
         */
        console.log(
            "Phone login API successful. Starting Firebase..."
        );

        console.log(
            "Phone login data:",
            response.data.data
        );

        setuserdata({
            ...response.data.data,
            access_token: response.data.access_token,
        });

        const phoneNumber =
            `${obj.country_code}${obj.contact_number}`;

        console.log(
            "Firebase Phone Number:",
            phoneNumber
        );

        /*
         * IMPORTANT:
         * setupRecaptcha() is async,
         * so we MUST await it.
         */
        const appVerifier = await createRecaptcha();

        console.log(
            "Firebase Recaptcha object:",
            appVerifier
        );

        console.log(
            "Calling Firebase signInWithPhoneNumber..."
        );

        const confirmationResult =
            await auth.signInWithPhoneNumber(
                phoneNumber,
                appVerifier
            );

        console.log(
            "Firebase OTP successfully sent:",
            confirmationResult
        );

        setotpdata(confirmationResult);
        setbtnloader(false);

        toster.success({
            title: "OTP sent to your registered mobile number"
        });

    } catch (error) {

        console.error(
            "========== LOGIN/FIREBASE ERROR =========="
        );

        console.error("Error:", error);
        console.error("Error code:", error?.code);
        console.error("Error message:", error?.message);
        console.error(
            "Response:",
            error?.response
        );

        console.error(
            "=========================================="
        );

        setbtnloader(false);

        toster.error({
            title:
                error?.message ||
                error?.response?.data?.message ||
                "Something went wrong"
        });
    }
}


  const userLogged = (userdata) => {
    toster.success({ title: "LoggedIn Successfully" })
    setobj({ ...objdata })
    setbtnloader(false)
    // Set bearer token for subsequent requests
    if (userdata?.access_token) {
      setAuthToken(userdata.access_token)
    }
    dispatch(riderlogin(userdata))
    setotpdata(null)
    localStorage.removeItem("driver")
    localStorage.removeItem("drivername")
    navi("/riderprofile")
  }


  async function verify(e) {
    e.preventDefault();

    const data = new FormData(e.currentTarget);
    const verificationCode = data.get("Verify");

    if (!otpdata) {
        toster.error({
            title: "Please request OTP first"
        });
        return;
    }

    setbtnloader(true);

    try {

        const result = await otpdata.confirm(verificationCode);

        console.log("Firebase login successful:", result);

        if (!userdata) {
            throw new Error("User login data not found");
        }

        console.log("Final user data:", userdata);

        // Get token from backend response saved in userdata
        const accessToken = userdata.access_token;
        const role = userdata.role;

        if (!accessToken) {
            throw new Error("Access token not received from server");
        }

        // Save authentication information
        localStorage.setItem(
            "access_token",
            accessToken
        );

        localStorage.setItem(
            "role",
            role || "rider"
        );

        // Set axios bearer token
        setAuthToken(accessToken);

        console.log("Access token saved:", accessToken);
        console.log("Role saved:", role);

        // Login Redux
        dispatch(riderlogin(userdata));

        // Success
        toster.success({
            title: "LoggedIn Successfully"
        });

        // Clear login state
        setotpdata(null);
        setobj({ ...objdata });
        setbtnloader(false);

        localStorage.removeItem("driver");
        localStorage.removeItem("drivername");

        // Navigate
        navi("/riderprofile");






    } catch (error) {

        console.error("OTP Verification Error:", error);

        setbtnloader(false);

        toster.error({
            title: error?.message || "Invalid OTP"
        });
    }
}

const resend = async () => {

    if (btnloader) {
        return;
    }

    try {

        setbtnloader(true);

        const phoneNumber =
            `${obj.country_code}${obj.contact_number}`;

        console.log("Resending OTP to:", phoneNumber);

        // Create a fresh reCAPTCHA
        const appVerifier = await createRecaptcha();

        console.log(
            "Application verifier:",
            appVerifier
        );

        const confirmationResult =
            await auth.signInWithPhoneNumber(
                phoneNumber,
                appVerifier
            );

        console.log(
            "Resend OTP successful:",
            confirmationResult
        );

        // Replace previous confirmation result
        setotpdata(confirmationResult);

        setbtnloader(false);

        toster.success({
            title: "OTP resent successfully"
        });

    } catch (error) {

        console.error(
            "========== RESEND OTP ERROR =========="
        );

        console.error("Error:", error);
        console.error("Code:", error?.code);
        console.error("Message:", error?.message);

        console.error(
            "======================================"
        );

        setbtnloader(false);

        // Clear invalid verifier
        if (recaptchaVerifierRef.current) {

            try {
                recaptchaVerifierRef.current.clear();
            } catch (e) {
                console.log("Clear verifier error:", e);
            }

            recaptchaVerifierRef.current = null;
        }

        toster.error({
            title:
                error?.message ||
                "Unable to resend OTP"
        });
    }
};



  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const onClose = () => {
    setModalOpen(false)
  }


  function changeagreestate(e) {
    setisagree(e)
    setOpenModal(false)
  }

  function closeVal() {
    setOpenModal(false)
  }

  return (
    <>
      <div className="driverreg">
        {otpdata ?
          <section className="sign-up-area pt-70 pb-70">
            <div className="container">
              <div className="row d-flex justify-content-center">
                <div className="col-lg-6 col-md-8 col-sm-10 col-12">
                  <div className="contact-form-action">
                    <div className="form-heading text-center">
                      <h3 className="form-title">Verify Your Otp</h3>
                      <p className="reset-desc">Enter  your six-digit otp that will receive on your  Contact No. If you have any issue about otp receive then contact us.</p>
                    </div>
                    <form onSubmit={verify}>
                      <div className="row">
                        <div className="col-lg-12 col-sm-12 col-12">
                          <div className="form-group">
                            <input className="form-control" type="text" name="Verify" placeholder="Enter Your Otp" required />
                          </div>
                        </div>

                        <div className="col-lg-12 col-sm-12 col-12">
                          <div className="row">
                            <div className="col-6 d-flex justify-content-start">
                              <button type="button" className="btn btn-outline-primary mt-4" onClick={resend}>
                                Resend Otp
                              </button>
                            </div>

                            <div className="col-6 d-flex justify-content-end">
                              {btnloader ? <CircularProgress /> : <button className="default-btn btn-two mt-4 m-0" type="submit">
                                Verify Otp
                              </button>
                              }
                            </div>
                          </div>
                        </div>
                        <div id="recaptcha-container"></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
          : <>
            <ForgotPasswordModal open={modalOpen} onClose={onClose} usertype={"drivers"} />
            <Modal open={openModal} onClose={() => setOpenModal(!openModal)}>
              <Box>
                <Termagree handlechange={changeagreestate} closeVal={closeVal} usertype={"driver"} />
              </Box>
            </Modal>
            <section className="sign-up-area">

              <div className="container">
                <div className="row d-flex justify-content-center">
                  <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 col-12">
                    <div className="contact-form-action">
                      <div className="form-heading text-center mb-3">
                        <h3 className="form-title">Login to your account!</h3>
                        <p className="form-desc">with your social network.</p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "flex-end" }}>
  <a
    style={{
      cursor: "pointer",
      background: "#e41e22",
      padding: "5px 20px",
      color: "white",
      borderRadius: "5px",
      textDecoration: "none",
    }}
    onClick={() => navi("/")}
  >
    Back
  </a>
</div>
                      <LoginTabs tab={tab} handleTabChange={handleTabChange} />
                      <form onSubmit={logdata}>
                        <div className="row">




                          {!(tab) ? <>
                            <div className="col-12 mb-2">
                              <label className="form-label">Registered Email</label>
                              <input required className="form-control mb-3" type="email" name="email" value={obj?.email} onChange={(e) => handlechange(e.target.name, e.target.value)} />
                            </div>
                            <div className="col-12 mb-2">
                              <label className="form-label">Password</label>
                              <input required className="form-control mb-3" type="password" name="password" value={obj?.password} onChange={(e) => handlechange(e.target.name, e.target.value)} minLength={"6"} />
                            </div>

                            <div className="col-12 mb-3 " style={{ display: "flex", justifyContent: "space-between" }}>
                              <div className="d-flex align-items-center">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked={isagree} />
                                <label class="form-check-label" for="flexCheckChecked" style={{ color: "#60686c", fontSize: 15, marginTop: "6px", marginLeft: "10px" }}>
                                I have read and understand the <span style={{ cursor: "pointer", color: "#117fb7", textDecoration: "underline" }} onClick={() => setOpenModal(true)}>Privacy Policy and Terms of Use <OpenInNew sx={{ fontSize: "10px" }} /></span>
                                </label>
                              </div>
                              <span style={{ cursor: "pointer", color: "#117fb7" }} onClick={() => setModalOpen(true)}>Forgot Password ?</span>
                            </div>
                          </> : <>

                            <div className="col-lg-3 col-sm-4 col-4 mb-2">
                              <label className="form-label">Country </label>
                              <select className="form-select form-control form-select-lg" value={obj?.country_code} name="country_code" onChange={(e) => handlechange(e.target.name, e.target.value)} required  >
                                <option defaultValue={" "}></option>
                                {code.map((row) => (
                                  <React.Fragment key={row.name}>
                                    <option value={row.dial_code}>{row.dial_code}  {row.name}</option>
                                  </React.Fragment>
                                ))}
                              </select>
                            </div>

                            <div className="col-lg-9 col-sm-8 col-8 mb-2">
                              <label className="form-label">Phone No.</label>
                              <input required className="form-control mb-3" type="tel" name="contact_number" value={obj?.contact_number} onChange={(e) => handlechange(e.target.name, e.target.value)} maxLength={"10"} />
                            </div>

                            <div className="col-12 mt-2 mb-3 d-flex align-items-center">
                              <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked={isagree} />
                              <label class="form-check-label" for="flexCheckChecked" style={{ color: "#60686c", fontSize: 15, marginTop: "6px", marginLeft: "10px" }}>
                                I have read and understand the <span style={{ cursor: "pointer", color: "#117fb7", textDecoration: "underline" }} onClick={() => setOpenModal(true)}>Privacy Policy and Terms of Use <OpenInNew sx={{ fontSize: "10px" }} /></span>
                              </label>
                            </div>

                          </>}

                          <div className="col-12">
                            {btnloader ? <CircularProgress /> :
                              <button className="default-btn btn-two" type="submit" disabled={!isagree}>
                                Log In Now
                              </button>
                            }
                          </div>

                          <div className="col-12">
                            <p className="account-desc">
                              Not a member?
                              <a style={{ cursor: "pointer" }} onClick={() => navi("/ridersignup")}>Register</a>
                            </p>
                          </div>

                          <div id='recaptcha-container'></div>

                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>

        }


      </div>
    </>
  );
}

export default Riderlogin;
